import { observable, makeObservable, action } from 'mobx';
import {
  waiting,
  State,
  deactivating,
  BulkInvitationsResource,
  deactivateSucceeded,
  reactivateSucceeded,
  confirmingDeactivate,
  reactivating,
} from './Types';
import { assertNever } from '@kofno/piper';
import InvitationsStore from '../../../Store';
import { MulticheckStore } from '../../../../../../../Multicheck/Store';
import { InvitationResource } from '../../../Store/Types';
import { TPlainTextKey } from '../../../../../../../Translations';
import { error } from '../../../../../../../ErrorHandling';

class BulkEditInvitationsStore {
  @observable
  state: State = waiting();

  readonly invitationsStore: InvitationsStore;

  constructor(invitationsStore: InvitationsStore) {
    makeObservable(this);
    this.invitationsStore = invitationsStore;
  }

  @action
  confirmingDeactivate = (multicheckStore: MulticheckStore<InvitationResource>) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'confirming-deactivate':
      case 'reactivating':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
      case 'error':
        this.state = confirmingDeactivate(multicheckStore);
        break;
      case 'deactivating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  deactivating = () => {
    switch (this.state.kind) {
      case 'confirming-deactivate':
        this.state = deactivating(this.state);
        break;
      case 'waiting':
      case 'error':
      case 'deactivating':
      case 'reactivating':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  reactivating = (multicheckStore: MulticheckStore<InvitationResource>) => {
    switch (this.state.kind) {
      case 'waiting':
      case 'confirming-deactivate':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
      case 'error':
        this.state = reactivating(multicheckStore);
        break;
      case 'deactivating':
      case 'reactivating':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };

  @action
  deactivateSucceeded = (resource: BulkInvitationsResource) => {
    switch (this.state.kind) {
      case 'deactivating':
        this.state = deactivateSucceeded(resource, this.state);
        break;
      case 'reactivating':
      case 'confirming-deactivate':
      case 'error':
      case 'waiting':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  reactivateSucceeded = (resource: BulkInvitationsResource) => {
    switch (this.state.kind) {
      case 'reactivating':
        this.state = reactivateSucceeded(resource, this.state);
        break;
      case 'deactivating':
      case 'confirming-deactivate':
      case 'error':
      case 'waiting':
      case 'deactivate-succeeded':
      case 'reactivate-succeeded':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default BulkEditInvitationsStore;
